import React from "react";
import Typography from "@material-ui/core/Typography";

export const WhatIsCA = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>What is CA?</u>
      </Typography>
      <p>
        Combined Arms is a 18+ milsim community that shares a common interest in
        enjoyable, tactical and organized milsim gaming. Our community has been
        running since September 2016 and is still constantly expanding!
      </p>
      <p>
        We strive to make our missions varied and interesting - from full cold
        war combined arms operations and Vietnam stealth assaults to ww2
        commando beach landings and cinematic combat paradrops. The one thing
        they all have in common is they all rely on a balance of teamwork and
        realism without encroaching on the reason we play games in the first
        place, which is to have fun!
      </p>
      <p>
        We don't enforce a policy regarding attendances or training, anyone 18+
        is welcome to drop by our subreddit at any time, sign up for any event
        and jump into the mission. For people new to the game, we have
        comprehensive guides to getting started and setting your mods up, as
        well as an extremely friendly community that is always happy to help.
      </p>
    </div>
  );
};

export default WhatIsCA;
